import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../../misc';

import FormattedPrice from '../../../misc/FormattedPrice';

import {
  MAGIC_LINK_SENT_MSG,
  MAGIC_LINK_EXPLANATION_MSG,
  NEW_SYSTEM_ORDER_REDIRECT_MSG,
  PHOTO_DVD_EXPLANATION_MSG,
  PHOTO_BOOK_MOBILE_MSG,
  PHOTO_BOOK_SHIPPING_CHARGES_MSG,
} from '../../../../utils/variables';

const NotificationDialogBody = ({ msg, msgType }) => {
  if (msg) {
    return (
      <span>
        {msg}
      </span>
    );
  }
  switch (msgType) {
    case MAGIC_LINK_SENT_MSG:
      return _renderMagicLinkSentBody();
    case MAGIC_LINK_EXPLANATION_MSG:
      return _renderMagicLinkExplanationBody();
    case NEW_SYSTEM_ORDER_REDIRECT_MSG:
      return _renderNewSystemOrderRedirectBody();
    case PHOTO_DVD_EXPLANATION_MSG:
      return _renderPhotoDvdExplanationBody();
    case PHOTO_BOOK_MOBILE_MSG:
      return _renderPhotoBookMobileBody();
    case PHOTO_BOOK_SHIPPING_CHARGES_MSG:
      return _renderPhotoBookShippingChargesBody();
  }
  return null;
};

function _renderMagicLinkSentBody() {
  return (
    <Fragment>
      <h1>
        <FormattedMessageWrappedInSpan
          id="notificationDialogBody.magicLinkSent.title"
          defaultMessage="Magic Link Sent!"
        />
      </h1>
      <FormattedMessageWrappedInSpan
        id="notificationDialogBody.magicLinkSent.message"
        defaultMessage="We have sent you an email with the link."
      />
    </Fragment>
  );
}

function _renderMagicLinkExplanationBody() {
  return (
    <Fragment>
      <h1>
        <FormattedMessageWrappedInSpan
          id="notificationDialogBody.magicLinkExplanation.title"
          defaultMessage="What is a magic link?"
        />
      </h1>
      <h2>
        <FormattedMessageWrappedInSpan
          id="notificationDialogBody.magicLinkExplanation.subtitle"
          defaultMessage="Your email address is your identity!"
        />
      </h2>
      <FormattedMessageWrappedInSpan
        id="notificationDialogBody.magicLinkExplanation.description"
        defaultMessage="A magic link helps us to protect your account! Instead of a user name, password or an order number we use your email address to verify your identity. So it is easy and save. Just enter your email address and we will send you a link. By clicking the magic link you will be automatically signed-in to your account.{br}The link is only valid for a limited time."
        values={{
          br: <br />,
        }}
      />
    </Fragment>
  );
}

function _renderNewSystemOrderRedirectBody() {
  return (
    <FormattedMessageWrappedInSpan
      id="notificationDialogBody.newSystemOrderRedirect.message"
      defaultMessage="You entered an order-id of our new shop system. Please login here, to see your order."
    />
  );
}

function _renderPhotoDvdExplanationBody() {
  return (
    <FormattedMessageWrappedInSpan
      id="notificationDialogBody.photoDvdExplanation.message"
      defaultMessage="The Photo-DVD contains all articles from your shopping cart. You have 3 days after ordering to change them (e.g. you can add more photos). The DVD is then produced and sent. We ship as a consignment of goods, this can sometimes take a while. Thank you for your patience."
    />
  );
}

function _renderPhotoBookMobileBody() {
  return (
    <FormattedMessageWrappedInSpan
      id="notificationDialogBody.photoBookMobile.message"
      defaultMessage="Please use a device with a larger screen (minimum width 960px) to design your personal myRacebook."
    />
  );
}

function _renderPhotoBookShippingChargesBody() {
  return (
    <div className="ndb-photo-book-shipping-charges">
      <table>
        <tbody>
          <tr>
            <td>
              <FormattedMessageWrappedInSpan
                id="notificationDialogBody.photoBookShippingCharges.message.germany"
                defaultMessage="Germany"
              />
            </td>
            <td>
              <FormattedPrice price={{ amount: 470, currency: 'EUR' }} />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessageWrappedInSpan
                id="notificationDialogBody.photoBookShippingCharges.message.international"
                defaultMessage="International"
              />
            </td>
            <td>
              <FormattedPrice price={{ amount: 950, currency: 'EUR' }} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

NotificationDialogBody.propTypes = {
  msg: PropTypes.string.isRequired,
  msgType: PropTypes.string.isRequired,
};

export default NotificationDialogBody;
